import { render, staticRenderFns } from "./ItemWidgetKakao.vue?vue&type=template&id=4cbef0b1&scoped=true&"
import script from "./ItemWidgetKakao.vue?vue&type=script&lang=js&"
export * from "./ItemWidgetKakao.vue?vue&type=script&lang=js&"
import style0 from "./ItemWidgetKakao.vue?vue&type=style&index=0&id=4cbef0b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbef0b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VLayout,VSpacer})
